import React, { useEffect, useState } from 'react';

import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

import useBlocRef from '../utils/useBlocRef.hook';

export default ({ children }) => {
  const blocRef = useBlocRef('appBloc');
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);
  const [workspaceDetails, setWorkspaceDetails] = useState(null);
  const [notPaidCasesTotal, setNotPaidCasesTotal] = useState(blocRef.current.notPaidCasesTotal$.getValue());
  const [notPaidCases, setNotPaidCases] = useState(blocRef.current.notPaidCases$.getValue());

  const { search } = useLocation();
  const { studyId } = queryString.parse(search);

  useEffect(() => {
    try {
      blocRef.current.getCurrentUser();
    } catch (ignore) {
      //
    }

    const subscription = blocRef.current.userDetails$.subscribe(setUserDetails);
    const workspaceSub = blocRef.current.userWorkspace$.subscribe(setWorkspaceDetails);
    const loadingSubscription = blocRef.current.loadingUserDetails$.subscribe(setLoading);
    const notPaidCasesTotalSub = blocRef.current.notPaidCasesTotal$.subscribe(setNotPaidCasesTotal);
    const notPaidCasesSub = blocRef.current.notPaidCases$.subscribe(setNotPaidCases);

    return () => {
      workspaceSub.unsubscribe();
      subscription.unsubscribe();
      loadingSubscription.unsubscribe();
      notPaidCasesTotalSub.unsubscribe();
      notPaidCasesSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!userDetails?.availableReport && !loading && (notPaidCasesTotal || !workspaceDetails?.canRequestBeforePay)) {
      const notPaidCase = notPaidCases?.[0] || undefined;
      const resourceId = notPaidCase?.resource?.id;

      const query = studyId || resourceId ? `?studyId=${studyId || resourceId}` : '';
      history.push(`/package-plans${query}`);
    }
  }, [history, loading, notPaidCases, notPaidCasesTotal, studyId, userDetails?.availableReport, workspaceDetails?.canRequestBeforePay]);

  return <>{children}</>;
};
